'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeCalendarPage$State(events, startDate, endDate, currentEvent, viewRecipe, mode, msgState, showDateRangeModal, dateRange, dateRangeTitle, dateRangeAction) {
  this.k6 = null;
  this.iK = null;
  this.iI = null;
  this.k5 = null;
  this.iL = null;
  this.je = null;
  this.iJ = null;
  this.mB = false;
  this.hP = null;
  this.iH = null;
  this.iG = null;
  this.k6 = events;
  this.iK = startDate;
  this.iI = endDate;
  this.k5 = currentEvent;
  this.iL = viewRecipe;
  this.je = mode;
  this.iJ = msgState;
  this.mB = showDateRangeModal;
  this.hP = dateRange;
  this.iH = dateRangeTitle;
  this.iG = dateRangeAction;
}
export { $c_Lmealorama_pages_RecipeCalendarPage$State as $c_Lmealorama_pages_RecipeCalendarPage$State };
$p = $c_Lmealorama_pages_RecipeCalendarPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_RecipeCalendarPage$State;
/** @constructor */
function $h_Lmealorama_pages_RecipeCalendarPage$State() {
}
export { $h_Lmealorama_pages_RecipeCalendarPage$State as $h_Lmealorama_pages_RecipeCalendarPage$State };
$h_Lmealorama_pages_RecipeCalendarPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k6));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iK));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iI));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k5));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iL));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.je));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iJ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.mB ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.hP));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iH));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.iG));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 11);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_RecipeCalendarPage$State)) {
    if ((this.mB === x$0.mB)) {
      var x = this.k6;
      var x$2 = x$0.k6;
      var $x_9 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$3 = this.iK;
      var x$4 = x$0.iK;
      var $x_8 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$5 = this.iI;
      var x$6 = x$0.iI;
      var $x_7 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$7 = this.k5;
      var x$8 = x$0.k5;
      var $x_6 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$9 = this.iL;
      var x$10 = x$0.iL;
      var $x_5 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$11 = this.je;
      var x$12 = x$0.je;
      var $x_4 = ((x$11 === null) ? (x$12 === null) : (x$11 === x$12));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$13 = this.iJ;
      var x$14 = x$0.iJ;
      var $x_3 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$15 = this.hP;
      var x$16 = x$0.hP;
      var $x_2 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$17 = this.iH;
      var x$18 = x$0.iH;
      var $x_1 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.iG, x$0.iG);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 11;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.k6;
      break;
    }
    case 1: {
      return this.iK;
      break;
    }
    case 2: {
      return this.iI;
      break;
    }
    case 3: {
      return this.k5;
      break;
    }
    case 4: {
      return this.iL;
      break;
    }
    case 5: {
      return this.je;
      break;
    }
    case 6: {
      return this.iJ;
      break;
    }
    case 7: {
      return this.mB;
      break;
    }
    case 8: {
      return this.hP;
      break;
    }
    case 9: {
      return this.iH;
      break;
    }
    case 10: {
      return this.iG;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_RecipeCalendarPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kA)));
}
export { $isArrayOf_Lmealorama_pages_RecipeCalendarPage$State as $isArrayOf_Lmealorama_pages_RecipeCalendarPage$State };
var $d_Lmealorama_pages_RecipeCalendarPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeCalendarPage$State, "mealorama.pages.RecipeCalendarPage$State", ({
  kA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeCalendarPage$State as $d_Lmealorama_pages_RecipeCalendarPage$State };
//# sourceMappingURL=mealorama.pages.-Recipe-Calendar-Page$-State.js.map
